import { getRealAvatarUrl } from './audioParticipantIdentity'

/**
 * Default candidate avatar URL when a photo is required elsewhere.
 * Audio cards prefer initials via getRealAvatarUrl() instead of this generic.
 * CTS-9778: swap when Rich provides the final asset.
 */
const DEFAULT_CANDIDATE_AVATAR =
  'https://www-yns-com.s3.amazonaws.com/images/icon_person_generic.png'

export function getCandidateAvatarUrl(candidate) {
  return getRealAvatarUrl(candidate) || DEFAULT_CANDIDATE_AVATAR
}

export { DEFAULT_CANDIDATE_AVATAR }
